module.exports = __webpack_public_path__ + "assets/img/baika.fbb5322.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/baika.png
// module id = 193
// module chunks = 45